import { SalaryDataService } from "../../services";
import { createCRUDThunksLegacy } from "../../shared/helpers";
import {
  ISalaryData,
  ISalaryDataRequest,
  ISalaryDataResponse,
} from "../../shared/types";

const service = new SalaryDataService();
export const salaryDataThunks = createCRUDThunksLegacy<
  ISalaryDataResponse,
  ISalaryDataRequest
>({
  service,
  resourceName: "salary-data",
});
